import platform from "@/platform"
import utils from "@/utils"
import bridges from "@/bridges"
import api from "@/api"

window.DEBUG = JSON.parse(localStorage.debug || false) || true
window._$ = utils

class Init {
  constructor() {
    this.ua = navigator.userAgent
    this.probes = [
      {
        name: "Hcap",
        regex: "^.*(LGE)+.*$"
      },
      {
        name: "Tizenv2",
        regex: "^.*(Tizen 6.5)+.*$"
      },
      {
        name: "Tizenv2",
        regex: "^.*(Tizen 9.0)+.*$"
      },
      {
        name: "Tizen",
        regex: "^.*(Tizen)+.*$"
      },
      {
        name: "PlaymoreTV",
        regex: "^.*(BeyondTV).+(ATV).+$"
      },
      {
        name: "PlaymoreTV",
        regex: "^.*(Arcelik Android TV).+(ATV).+$"
      },
      {
        name: "PlaymoreTV",
        regex: "^.*(Beko Android TV).+(ATV).+$"
      },
      {
        name: "PlaymoreTV",
        regex: "^.*(PlaymoreTV).+(ATV).+$"
      },
      {
        name: "PlaymoreGTV",
        regex: "^(?=.*Playmore\\()(?=.*ATV)(?=.*PLATFORM/GTV).*$"
      },
      {
        name: "PlaymoreATV",
        regex: "^.*(Playmore).+(ATV).+$"
      },
      {
        name: "Philips",
        regex: "^.*(Playmore).+(JEDI).+$"
      },
      {
        name: "Playmore",
        regex: "^.*(Playmore)+.*$"
      },
      {
        name: "Samsung",
        regex: "^.*(SmartHub)+.*$"
      },
      {
        name: "Wixpv2",
        regex: "^.*(Andr0id 9.0)+.*(JAPIT-WIXP-Version)+.*$"
      },
      {
        name: "Wixp",
        regex: "^.*(JAPIT-WIXP-Version)+.*$"
      },
      {
        name: "Vestel",
        regex: "^.*(Vestel|VSTVB)+.*$"
      },
      {
        name: "Universal",
        regex: "^.*(Windows NT)+.*$"
      }
    ]
    this.bootstrap = {
      classes: [],
      resolve: null,
      reject: null,
      promise: null
    }

    this.bootstrap.promise = new Promise((resolve, reject) => {
      this.bootstrap.resolve = resolve
      this.bootstrap.reject = reject
    })
  }

  async start() {
    await this.sleep(1000)

    if (!this.ua.includes("WebKit")) throw "The browser engine haven't webkit core"

    let result

    this.probes.forEach(probe => {
      const regex = new RegExp(probe.regex)
      if (result) return
      else if (regex.test(this.ua)) result = probe.name.toLowerCase()
    })

    //if (!result) throw `The device you tried is not compatible.`
    if (!result) result = "universal"

    let library = bridges.hasOwnProperty(result) && bridges[result]
    if (!library) throw `The "${result}" bridge is not found.`
    _$.log(`The "${result}" bridge is found.`)

    window.__ = Object.assign({}, platform, library)
    this.bootstrap.classes = Object.keys(window.__).sort()

    if (!this.bootstrap.classes.length) throw "The init process needs at least one class."

    window.__.api = api

    return true
  }
  async mount() {
    this.startBootstrap()

    const bsResponse = await this.bootstrap.promise

    return bsResponse
  }

  async startBootstrap() {
    if (!this.bootstrap.classes.length) {
      this.bootstrap.resolve(true)
      return true
    }

    this.bootClass()
      .then(() => this.startBootstrap())
      .catch(err => this.bootstrap.reject(`while initializing classes - ${err.message || err}`))
  }

  async bootClass() {
    const shifted = this.bootstrap.classes.shift(),
      _class = window.__[shifted]
    if (_class && _class._init && typeof _class._init === "function") {
      _$.log(shifted + " initializing")
      const res = await _class._init()
      if (!res) window.__[shifted] = null
      else _$.log(shifted + " initialized")
    }

    return true
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}

export default new Init()
